import { render, staticRenderFns } from "./UsarCinturon.vue?vue&type=template&id=77d219bb&scoped=true&"
import script from "./UsarCinturon.vue?vue&type=script&lang=js&"
export * from "./UsarCinturon.vue?vue&type=script&lang=js&"
import style0 from "./UsarCinturon.vue?vue&type=style&index=0&id=77d219bb&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d219bb",
  null
  
)

export default component.exports